export default "__VITE_PUBLIC_ASSET__b4d8f8dd__"